import { z } from 'zod';
const DEFAULT_LABEL = '<redacted>';
export const LAST4_MASK_PREFIX = '••••';
export const GARBLED_LAST4_MASK_PREFIX = '\u00e2\u20ac\u00a2'.repeat(4);
export function isSecretMask(value) {
    const text = value.trim();
    return (text === DEFAULT_LABEL ||
        text.startsWith(LAST4_MASK_PREFIX) ||
        text.startsWith(GARBLED_LAST4_MASK_PREFIX));
}
const INSPECT = Symbol.for('nodejs.util.inspect.custom');
const values = new WeakMap();
const labels = new WeakMap();
function storedValue(owner) {
    return values.get(owner);
}
export class Secret {
    constructor(value, label = DEFAULT_LABEL) {
        values.set(this, value);
        labels.set(this, label);
    }
    get value() {
        return storedValue(this);
    }
    reveal() {
        return storedValue(this);
    }
    map(fn) {
        return new Secret(fn(storedValue(this)), labels.get(this) ?? DEFAULT_LABEL);
    }
    toString() {
        return labels.get(this) ?? DEFAULT_LABEL;
    }
    toJSON() {
        return labels.get(this) ?? DEFAULT_LABEL;
    }
    [INSPECT]() {
        return labels.get(this) ?? DEFAULT_LABEL;
    }
    static is(value) {
        return value instanceof Secret;
    }
}
export function secret(value, label = DEFAULT_LABEL) {
    return new Secret(value, label);
}
export function zSecret(inner, label) {
    return inner.transform((value) => secret(value, label));
}
//# sourceMappingURL=secret.js.map